import React from "react";
var __jsx = React.createElement;
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useIntl } from 'react-intl';
import Input from 'components/common/Input';

var ReadOnlyField = function ReadOnlyField(_ref) {
  var formField = _ref.formField;
  var intl = useIntl();
  var fieldNameToCopy = formField.copyOf === undefined ? '' : formField.copyOf;

  var _useFormContext = useFormContext(),
      setValue = _useFormContext.setValue;

  var fieldValue = useWatch({
    name: fieldNameToCopy,
    defaultValue: ''
  });
  useEffect(function () {
    if (formField.copyOf !== undefined) {
      setValue(formField.name, fieldValue);
    }
  }, [fieldValue, formField, setValue]);
  return __jsx(Input, {
    defaultValue: formField.defaultValue,
    name: formField.name,
    label: intl.formatMessage({
      id: formField.labelId
    }),
    disabled: true
  });
};

export default ReadOnlyField;